/**
 * Input — Campo de texto dark theme com ícone e props extras
 */
import type { JSX } from 'preact';
import { useRef, useEffect } from 'preact/hooks';
import { T, CT } from '../../styles/tokens';

interface InputProps {
  label?: string;
  type?: string;
  value: string | number;
  onChange: (v: string) => void;
  placeholder?: string;
  error?: string;
  helper?: string;
  disabled?: boolean;
  style?: JSX.CSSProperties;
  icon?: any;
  name?: string;
  autoFocus?: boolean;
  onBlur?: () => void;
}

export function Input({ label, type = 'text', value, onChange, placeholder, error, helper, disabled, style, icon, name, autoFocus, onBlur }: InputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) inputRef.current.focus();
  }, [autoFocus]);

  return (
    <div style={{ marginBottom: 0 }}>
      {label && (
        <label style={{ display: 'block', fontSize: T.textSm, fontWeight: T.weightSemibold, color: T.textSecondary, marginBottom: 6 }}>
          {label}
        </label>
      )}
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        {icon && (
          <span style={{
            position: 'absolute', left: 10, display: 'flex', alignItems: 'center',
            color: T.textMuted, pointerEvents: 'none',
          }}>
            {icon}
          </span>
        )}
        <input
          ref={inputRef}
          type={type}
          value={value}
          name={name}
          onInput={(e: any) => onChange(e.target.value)}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          style={{
            width: '100%',
            padding: icon ? '10px 12px 10px 34px' : '10px 12px',
            fontSize: CT.input.fontSize,
            color: CT.input.text,
            background: CT.input.bg,
            border: `1px solid ${error ? T.danger : CT.input.border}`,
            borderRadius: CT.input.radius,
            outline: 'none',
            transition: `border-color ${T.transitionFast}`,
            opacity: disabled ? 0.5 : 1,
            boxSizing: 'border-box',
            ...style,
          }}
        />
      </div>
      {(error || helper) && (
        <div style={{ fontSize: T.textXs, marginTop: T.space1, color: error ? T.danger : T.textMuted }}>
          {error || helper}
        </div>
      )}
    </div>
  );
}
